import Axios from "axios";
import { ApiBaseUrl, LoanBaseUrl } from "../config/config";
import { GetStatusResponse } from "../models/basicInformation.model";
import { ApiResultModel } from "../models/common.model";
import {
  ActivateLoanRequestBySupplierResponse,
  CancelLoanRequest,
  DeleteSupplierAttachmentRequest,
  DoLoanActionRequest,
  Filter,
  FilterRegister,
  GetCancellationReasonsResponse,
  GetCustomerRegistrationInfoRequest,
  GetCustomerRegistrationInfoResponse,
  GetInProcessLoansFilter,
  GetInProcessLoansRequest,
  GetInProcessLoansResponse,
  GetInstallmentTableRequest,
  GetInstallmentTableResponse,
  GetLegacyContractsResponse,
  GetLoanInfoRequest,
  GetSimilarLoanResponse,
  GetSupplierAttachmentsRequest,
  ProcessPayingInstallmentFileResponse,
  ReferenceKeyRequest,
  RegisterLoanBySupplierRequest,
  RegisterLoanBySupplierResponse,
  SearchLoanRegisterRequestsRequest,
  SearchLoanRequestsRequest,
  SearchLoanRequestsResponse,
  UploadSupplierAttachmentRequest,
  UploadSupplierAttachmentResponse,
} from "../models/loan.model";
import { ReferenceKey } from "../models/cartable.model";

export const searchLoanRequests = (
  data: SearchLoanRequestsRequest
): Promise<ApiResultModel<SearchLoanRequestsResponse[]>> => {
  return Axios.post<ApiResultModel<SearchLoanRequestsResponse[]>>(
    ApiBaseUrl + LoanBaseUrl + "/SearchLoanRequests",
    data
  ).then((result) => {
    return result.data;
  });
};

export const exportLoanRequests = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + LoanBaseUrl + "/ExportLoanRequests",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${data.cartableTitle ? data.cartableTitle : "جدول جستجو"} .xlsx`
    );
    document.body.appendChild(link);
    link.click();
  });
};
export const searchLoanRequestsReportExcel = async (
  data: SearchLoanRegisterRequestsRequest
) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + LoanBaseUrl + "/SearchLoanRequestsReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${
        data?.filter?.cartableTitle ? data.filter.cartableTitle : "جدول جستجو"
      }.xlsx`
    );
    document.body.appendChild(link);
    link.click();
  });
};

export const searchLoanRegisterRequests = (
  data: SearchLoanRegisterRequestsRequest
): Promise<ApiResultModel<SearchLoanRequestsResponse[]>> => {
  return Axios.post<ApiResultModel<SearchLoanRequestsResponse[]>>(
    ApiBaseUrl + LoanBaseUrl + "/SearchLoanRegisterRequests",
    data
  ).then((result) => {
    return result.data;
  });
};
export const exportLoanRegisterRequests = async (data: FilterRegister) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + LoanBaseUrl + "/ExportLoanRegisterRequests",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${data.cartableTitle ? data.cartableTitle : "پرونده"}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
  });
};
export const registerLoanBySupplier = (
  data: RegisterLoanBySupplierRequest
): Promise<RegisterLoanBySupplierResponse> => {
  return Axios.post<ApiResultModel<RegisterLoanBySupplierResponse>>(
    ApiBaseUrl + LoanBaseUrl + "/RegisterLoanBySupplier",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const sendLoanActivationCodeToCustomer = (
  data: ReferenceKeyRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + LoanBaseUrl + "/SendLoanActivationCodeToCustomer",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const activateLoanRequestBySupplier = (
  data: ReferenceKeyRequest
): Promise<ApiResultModel<ActivateLoanRequestBySupplierResponse>> => {
  return Axios.post<ApiResultModel<ActivateLoanRequestBySupplierResponse>>(
    ApiBaseUrl + LoanBaseUrl + "/ActivateLoanRequestBySupplier",
    data
  ).then((result) => {
    return result.data;
  });
};

export const getSupplierAttachments = (
  data: GetSupplierAttachmentsRequest
): Promise<UploadSupplierAttachmentResponse[]> => {
  return Axios.post<ApiResultModel<UploadSupplierAttachmentResponse[]>>(
    ApiBaseUrl + LoanBaseUrl + "/GetSupplierAttachments",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const deleteSupplierAttachment = (
  data: DeleteSupplierAttachmentRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + LoanBaseUrl + "/DeleteSupplierAttachment",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const uploadSupplierAttachment = (
  data: UploadSupplierAttachmentRequest
): Promise<UploadSupplierAttachmentResponse> => {
  const formData = new FormData();
  if (data.LoanRequestId)
    formData.append("LoanRequestId", data.LoanRequestId.toString());
  formData.append("DocumentType", data.DocumentType!.toString());
  if (data.FileData) formData.append("FileName", data.FileData.name);
  if (data.FileData) formData.append("FileData", data.FileData);
  return Axios.post<ApiResultModel<UploadSupplierAttachmentResponse>>(
    ApiBaseUrl + LoanBaseUrl + "/UploadSupplierAttachment",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data; charset=utf-8",
      },
    }
  ).then((result) => {
    return result.data.data;
  });
};

export const getCustomerRegistrationInfo = (
  data: GetCustomerRegistrationInfoRequest
): Promise<GetCustomerRegistrationInfoResponse> => {
  return Axios.post<ApiResultModel<GetCustomerRegistrationInfoResponse>>(
    ApiBaseUrl + LoanBaseUrl + "/GetCustomerRegistrationInfo",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const cancelLoanRequestBySupplier = (
  data: ReferenceKeyRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + LoanBaseUrl + "/CancelLoanRequestBySupplier",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const getInstallmentTable = async (
  data: GetInstallmentTableRequest
): Promise<ApiResultModel<GetInstallmentTableResponse[]>> => {
  return await Axios.post<ApiResultModel<GetInstallmentTableResponse[]>>(
    ApiBaseUrl + LoanBaseUrl + "/GetInstallmentTable",
    data
  ).then((result) => {
    return result.data;
  });
};

export const exportInstallmentCheques = async (
  data: GetInstallmentTableRequest
) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + LoanBaseUrl + "/ExportInstallmentCheques",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    // link.setAttribute('download', `${Date.now()}.xlsx`);
    link.setAttribute(
      "download",
      ` ${data.cartableTitle ? data.cartableTitle : "جدول"}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
  });
};
export const GetLegacyContracts = (
  data: GetLoanInfoRequest
): Promise<ApiResultModel<GetLegacyContractsResponse[]>> => {
  return Axios.post<ApiResultModel<GetLegacyContractsResponse[]>>(
    ApiBaseUrl + LoanBaseUrl + "/GetLegacyContracts",
    data
  ).then((result) => {
    return result.data;
  });
};
export const GetSimilarLoanRequests = (
  data: ReferenceKey
): Promise<ApiResultModel<GetSimilarLoanResponse[]>> => {
  return Axios.post<ApiResultModel<GetSimilarLoanResponse[]>>(
    ApiBaseUrl + LoanBaseUrl + "/GetSimilarLoanRequests",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetLoanRequestStatuses = (): Promise<GetStatusResponse[]> => {
  return Axios.post<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + LoanBaseUrl + "/GetLoanRequestStatuses"
  ).then((result) => {
    return result.data.data;
  });
};

export const DoLoanAction = async (
  data: DoLoanActionRequest
): Promise<{ result: boolean }> => {
  return await Axios.post<ApiResultModel<{ result: boolean }>>(
    ApiBaseUrl + LoanBaseUrl + "/DoLoanAction",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const CancelLoan = async (data: CancelLoanRequest): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + LoanBaseUrl + "/CancelLoan",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const GetCancellationReasons = async (): Promise<GetCancellationReasonsResponse[]> => {
  return await Axios.get<ApiResultModel<GetCancellationReasonsResponse[]>>(
    ApiBaseUrl + LoanBaseUrl + "/GetCancellationReasons"
  ).then((result) => {
    return result.data.data;
  });
};
export const GetInProcessLoans = async (
  data: GetInProcessLoansRequest
): Promise<ApiResultModel<GetInProcessLoansResponse[]>> => {
  return await Axios.post<ApiResultModel<GetInProcessLoansResponse[]>>(
    ApiBaseUrl + LoanBaseUrl + "/GetInProcessLoans",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetInProcessLoansReportExcel = async (
  data: GetInProcessLoansFilter
) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + LoanBaseUrl + "/GetInProcessLoansReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"لیست وام های درجریان"}.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const ProcessDelayedInstallments = async (data: {
  processId: number;
}): Promise<ApiResultModel<boolean>> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + LoanBaseUrl + "/ProcessDelayedInstallments",
    data
  ).then((result) => {
    return result.data;
  });
};

export const ProcessPayingInstallmentFile = (
  data: File
): Promise<ProcessPayingInstallmentFileResponse> => {
  const formData = new FormData();
  if (data) formData.append("File", data);
  return Axios.post<ApiResultModel<ProcessPayingInstallmentFileResponse>>(
    ApiBaseUrl + LoanBaseUrl + "/ProcessPayingInstallmentFile",
    formData
  ).then((result) => {
    return result.data.data;
  });
};

export const GetInvalidInstallmentItems = async (data: {
  processId: number;
}) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + LoanBaseUrl + "/GetInvalidInstallmentItems",
    data,
    responseType: "blob",
    // headers: {
    //   "Content-Type": "application/json",
    //   Accept: "application/pdf",
    // },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"لیسترکوردهای خطادار"}.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
